import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Edit = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M3.9341 21.2034c-.3191 0-.5886-.1098-.8082-.3293-.2195-.2196-.3293-.4891-.3293-.8082v-2.5565c0-.3025.057-.5916.171-.8673a2.2218 2.2218 0 01.4878-.73L15.9846 3.4019c.208-.1954.4389-.345.6925-.449a2.083 2.083 0 01.7983-.156c.2746 0 .543.052.805.156.2618.104.4924.26.6917.468l1.632 1.639c.208.1953.3609.425.4585.689.0977.2638.1465.5287.1465.7947 0 .2787-.0488.5458-.1465.8013-.0976.2556-.2505.4875-.4585.6955L8.0999 20.5446a2.221 2.221 0 01-.7303.4878 2.2455 2.2455 0 01-.867.171H3.9341zM17.4684 7.9376l1.4-1.394-1.406-1.412-1.406 1.4 1.412 1.406z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M5.0656 18.9284h1.431l9.3685-9.3685-1.419-1.425-9.3805 9.3805v1.413zm-1.1315 2.275c-.3191 0-.5886-.1098-.8082-.3293-.2195-.2196-.3293-.4891-.3293-.8082v-2.5565c0-.3025.057-.5916.171-.8673a2.2218 2.2218 0 01.4878-.73L15.9846 3.4019c.208-.1954.4389-.345.6925-.449a2.083 2.083 0 01.7983-.156c.2746 0 .543.052.805.156.2618.104.4924.26.6917.468l1.632 1.639c.208.1953.3609.425.4585.689.0977.2638.1465.5287.1465.7947 0 .2787-.0488.5458-.1465.8013-.0976.2556-.2505.4875-.4585.6955L8.0999 20.5446a2.221 2.221 0 01-.7303.4878 2.2455 2.2455 0 01-.867.171H3.9341zm11.212-12.3495l-.7-.719 1.419 1.425-.719-.706z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M5.0656 18.9284h1.431l9.3685-9.3685-1.419-1.425-9.3805 9.3805v1.413zm-1.1315 2.275c-.3191 0-.5886-.1098-.8082-.3293-.2195-.2196-.3293-.4891-.3293-.8082v-2.5565c0-.3025.057-.5916.171-.8673a2.2218 2.2218 0 01.4878-.73L15.9846 3.4019c.208-.1954.4389-.345.6925-.449a2.083 2.083 0 01.7983-.156c.2746 0 .543.052.805.156.2618.104.4924.26.6917.468l1.632 1.639c.208.1953.3609.425.4585.689.0977.2638.1465.5287.1465.7947 0 .2787-.0488.5458-.1465.8013-.0976.2556-.2505.4875-.4585.6955L8.0999 20.5446a2.221 2.221 0 01-.7303.4878 2.2455 2.2455 0 01-.867.171H3.9341zm11.212-12.3495l-.7-.719 1.419 1.425-.719-.706z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Edit.displayName = "EditIcon";

export { Edit, Edit as default };
